module.exports = __webpack_public_path__ + "static/media/ResourceT2.c040668d.jpeg";